<template>
  <div>
    <custom-actions>
      <template #header>
        <!-- <el-button v-if="hasSetting2" type="primary" @click="onSetting2">点价数量设置</el-button> -->
        <!-- <el-button v-if="hasSetting" type="primary" @click="onSetting">点价时间设置</el-button> -->
        <el-button v-if="hasExport" type="primary" @click="onDownExcel">导出</el-button>
        <el-button v-if="hasExport && orderType === '2'" type="primary" @click="downloadPurchaseReport('basis')">基差合同点价表</el-button>
        <el-button v-if="hasExport" type="primary" @click="downloadPurchaseReport('execution')">散油合同执行表</el-button>
        <el-button v-if="hasAdd" type="primary"
                   @click="$router.push('/ycorderManage/add?orderType=' + orderType)">新增采购订单</el-button>
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
               label-width="100px">
        <el-form-item label="供应商名称" prop="userName">
          <!-- <el-select clearable filterable v-model="searchForm.userId" placeholder="请选择客户名称">
            <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
              :key="index"></el-option>
          </el-select> -->
          <el-input clearable v-model="searchForm.userName" placeholder="请输入供应商名称" />
        </el-form-item>
        <el-form-item label="合同编号" prop="contractNo">
          <el-input clearable v-model='searchForm.contractNo' placeholder="请输入合同编号" />
        </el-form-item>
        <el-form-item label="订单编号" prop="orderNumber">
          <el-input clearable v-model='searchForm.orderNumber' placeholder="请输入订单编号" />
        </el-form-item>
        <!-- 外部点价编号仅用于暂定价订单的筛选。 -->
        <el-form-item v-if="orderType === '2'" label="外部点价编号" prop="priceOrderNo">
          <el-input clearable v-model="searchForm.priceOrderNo" placeholder="请输入外部点价编号" />
        </el-form-item>

        <el-form-item label="商品名称" prop="specName">
          <el-input clearable v-model="searchForm.specName" placeholder="请输入商品名称" />
        </el-form-item>

        <el-form-item label="订单状态" prop="orderStatus">
          <el-select clearable filterable v-model="searchForm.orderStatus" placeholder="请选择订单状态">
            <el-option v-for="(item, index) of orderStatusList" :value="item.value" :label="item.label"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="保证金类型" prop="orderDepositType">
          <el-select clearable filterable v-model="searchForm.orderDepositType" placeholder="请选择保证金类型">
            <el-option v-for="(item, index) of orderDepositTypeList" :value="item.value" :label="item.label"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单日期" prop="dateArr">
          <el-date-picker v-model="dateArr" type="daterange" range-separator="至" start-placeholder="开始日期"
                          end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table v-if="orderType === '1'" key="1" size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="200" label="采购方" prop="userName"></el-table-column>
        <el-table-column min-width="200" label="供应商名称" prop="supplierName"></el-table-column>

        <el-table-column min-width="200" label="合同编号" prop="contractNo"></el-table-column>
        <!-- 一口价订单无需点价，不展示暂定价合同的点价信息。 -->
        <el-table-column min-width="230" label="订单编号" prop="orderNumber">
          <template v-slot="{ row }">
            <el-button type="text"
                       @click="$router.push('/ycorderManage/deliveryOrder?orderId=' + row.orderId + '&orderType=' + orderType)">{{
                row.orderNumber }}</el-button>
            <el-button v-if="row.orderNumber" type="text" size="mini" @click.stop="handleCopyOrderNo(row.orderNumber)">复制</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column min-width="140" label="提货日期" prop="pickupDate">
          <template v-slot="{ row }">
            <span>{{ row.pickupDate || "--" }}</span>
            <el-button type="text" v-if="hasEditDate && ['1', '2'].includes(row.orderStatus)"
              @click="onEditDate(row)">修改</el-button>
          </template>
        </el-table-column> -->
        <el-table-column min-width="220" show-overflow-tooltip label="商品名称" prop="specName"></el-table-column>
        <el-table-column v-if="orderType === '1'" min-width="120" label="锁定单价(元)" prop="lockedPrice">
          <template v-slot="{ row }">
            {{ row.lockedPrice || "--" }}
          </template>
        </el-table-column>
        <el-table-column v-if="orderType === '2'" min-width="120" label="暂定单价(元)" prop="lockedPrice">
          <template v-slot="{ row }">
            <span>{{ row.lockedPrice - row.priceDiff }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="确认价" v-if="orderType == '2'" prop="lockedPrice">
          <template v-slot="{ row }">
            {{ (orderType === '2' && row.parentOrderId) ? row.lockedPrice : '--' }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" :label="orderType == '1' ? '锁定数量' : '总数'"
                         prop="orderQuantity"></el-table-column>
        <el-table-column min-width="120" label="已用数量" prop="usedQuantity"></el-table-column>
        <el-table-column min-width="180" v-if="orderType === '1'" label="提货进行中数量"
                         prop="usedAddQuantity"></el-table-column>
        <el-table-column min-width="120" v-if="orderType === '1'" label="可用数量" prop="kyQuantity"></el-table-column>
        <!-- <el-table-column min-width="120" label="价格差(元)" prop="priceDiff"></el-table-column> -->
        <el-table-column min-width="120" label="保证金类型" prop="orderDepositType">
          <template v-slot="{ row }">
            {{ orderDepositTypeMap.get(row.orderDepositType) }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="保证金比例" prop="orderDeposit">
          <template v-slot="{ row }">
            {{ row.orderDeposit }}{{ row.orderDepositType && row.orderDepositType === '2' ? (row.specUnit ? '/' + row.specUnit : '') : '%' }}
          </template>
        </el-table-column>
        <el-table-column min-width="180" label="锁定保证金" prop="lockedDeposit">
          <template v-slot="{ row }">
            {{ row.lockedDepositDeposit }}
          </template>
        </el-table-column>
        <!-- <el-table-column min-width="180" label="锁定保证金(充值)(元)" prop="lockedDepositDeposit"></el-table-column> -->
        <!-- <el-table-column min-width="180" label="锁定保证金(其他)(元)" prop="lockedPickupDeposit"></el-table-column> -->
        <el-table-column min-width="120" label="订单状态" prop="orderStatus">
          <template v-slot="{ row }">
            <template v-if="row.resState !== '1'">
              <el-tag type="warning">货转中</el-tag>
            </template>
            <template v-else-if="['2', '3'].includes(row.hgState)">
              <el-tag type="warning">回购中</el-tag>
            </template>
            <template v-else>
              <el-tag type="warning" v-if="row.orderStatus == '1'">待审批</el-tag>
              <el-tag type="primary" v-if="row.orderStatus == '2'">进行中</el-tag>
              <el-tag type="success" v-if="row.orderStatus == '3'">已完成</el-tag>
              <el-tag type="danger" v-if="row.orderStatus == '4'">驳回作废</el-tag>
            </template>
          </template>
        </el-table-column>
        <el-table-column min-width="140" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column width="270" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text"
                       @click="$router.push('/ycorderManage/detail?orderId=' + row.orderId + '&orderType=' + orderType)">详情</el-button>
            <el-button type="text" v-if="row.orderStatus == 1 && hasApproval" @click="onAppoval(row)">审批</el-button>
            <!-- 一口价订单不提供外部点价编号填写入口。 -->
            <el-button type="text" v-if="!row.resPrice && row.hgState === '2' && hasApprovalHg2"
                       @click="onAppovalHgJe(row)">填写补贴金额</el-button>
            <el-button type="text" v-if="row.resPrice && row.hgState === '2' && hasApprovalHg2"
                       @click="onAppovalHg(row)">回购审批</el-button>
            <el-button type="text" v-if="row.resPrice && row.hgState === '3' && hasApprovalHg3"
                       @click="onAppovalHg(row)">回购审批</el-button>
            <el-button type="text" v-if="['2', '3'].includes(row.hgState) && row.resPrice"
                       @click="onDownExcel2(row.orderId)">导出回购单</el-button>
            <!-- <el-button type="text"
              v-if="row.orderStatus == 2 && hasTransfer && row.resState === '1' && !row.parentOrderId"
              @click="onTransfer(row)">货权转让</el-button> -->
            <el-button type="text"
                       v-if="row.orderStatus == 2 && hasEditNum && row.resState === '1' && !row.parentOrderId"
                       @click="onEditNumr(row)">提货配置</el-button>
            <el-button type="text" v-if="row.orderStatus == 2 && hasComplete && row.resState === '1'"
                       @click="onComplete(row)">完成</el-button>
            <el-button type="text" v-if="row.parentOrderId && row.orderStatus === '2' && hasReturn"
                       @click="onReturn(row)">退回</el-button>
            <el-button v-if="hasDel && row.resState === '1'" type="text" @click="deleteRow(row.orderId)"
                       class="del-btn">删除</el-button>
            <el-button v-if="row.orderStatus == 2 && hasRelation" type="text" @click="$router.push('/ycorderManage/relation?orderId=' + row.orderId + '&orderType=' + orderType)">关联</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table v-if="orderType === '2'" key="2" size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="200" label="采购方" prop="userName"></el-table-column>
        <el-table-column min-width="200" label="供应商名称" prop="supplierName"></el-table-column>

        <el-table-column min-width="200" label="合同编号" prop="contractNo"></el-table-column>
        <!-- 暂定价订单展示审批后补录的外部点价编号。 -->
        <el-table-column min-width="180" label="外部点价编号" prop="priceOrderNo"></el-table-column>
        <el-table-column min-width="140" label="最晚点价日期" prop="latestPriceDate"></el-table-column>
        <el-table-column min-width="140" label="期货合约" prop="futuresContract"></el-table-column>
        <el-table-column min-width="100" label="基差" prop="basisPrice"></el-table-column>
        <el-table-column min-width="230" label="订单编号" prop="orderNumber">
          <template v-slot="{ row }">
            <el-button type="text"
                       @click="$router.push('/ycorderManage/deliveryOrder?orderId=' + row.orderId + '&orderType=' + orderType)">{{
                row.orderNumber }}</el-button>
            <el-button v-if="row.orderNumber" type="text" size="mini" @click.stop="handleCopyOrderNo(row.orderNumber)">复制</el-button>
          </template>
        </el-table-column>
        <el-table-column min-width="220" show-overflow-tooltip label="商品名称" prop="specName"></el-table-column>
        <el-table-column min-width="120" label="暂定单价(元)" prop="lockedPrice">
          <template v-slot="{ row }">
            <span v-if="!row.parentOrderId">{{ row.lockedPrice - row.priceDiff }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="合同总数" prop="lockedPrice">
          <template v-slot="{ row }">
            <span v-if="!row.parentOrderId">{{ (parseInt(row.orderQuantity) || 0) + (parseInt(row.ydQuantity) || 0)
              }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="已点数量" prop="ydQuantity">
          <template v-slot="{ row }">
            <span v-if="!row.parentOrderId">{{ row.ydQuantity }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="未点数量" prop="orderQuantity">
          <template v-slot="{ row }">
            <span v-if="!row.parentOrderId">{{ row.orderQuantity }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="点价单价" prop="lockedPrice">
          <template v-slot="{ row }">
            <span v-if="row.parentOrderId">{{ row.lockedPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="点价总数" prop="orderQuantity">
          <template v-slot="{ row }">
            <span v-if="row.parentOrderId">{{ row.orderQuantity }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="已提数量" prop="usedQuantity"></el-table-column>
        <el-table-column min-width="120" label="未提数量">
          <template v-slot="{ row }">
            {{ parseFloat((row.orderQuantity - row.usedQuantity).toFixed(3)) }}
          </template>
        </el-table-column>
        <el-table-column v-if="orderType === '1'" min-width="120" label="锁定单价(元)" prop="lockedPrice">
          <template v-slot="{ row }">
            {{ row.lockedPrice || "--" }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="保证金类型" prop="orderDepositType">
          <template v-slot="{ row }">
            {{ orderDepositTypeMap.get(row.orderDepositType) }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="保证金比例" prop="orderDeposit">
          <template v-slot="{ row }">
            {{ row.orderDeposit }}{{ row.orderDepositType && row.orderDepositType === '2' ? (row.specUnit ? '/' + row.specUnit : '') : '%' }}
          </template>
        </el-table-column>
        <el-table-column min-width="180" label="锁定保证金" prop="lockedDeposit">
          <template v-slot="{ row }">
            {{ row.lockedDepositDeposit }}
          </template>
        </el-table-column>
        <!-- <el-table-column min-width="180" label="锁定保证金(充值)(元)" prop="lockedDepositDeposit"></el-table-column> -->
        <!-- <el-table-column min-width="180" label="锁定保证金(其他)(元)" prop="lockedPickupDeposit"></el-table-column> -->
        <el-table-column min-width="140" label="提货日期" prop="pickupDate">
          <template v-slot="{ row }">
            <span>{{ row.pickupDate || "--" }}</span>
            <el-button type="text" v-if="hasEditDate && ['1', '2'].includes(row.orderStatus)"
                       @click="onEditDate(row)">修改</el-button>
          </template>
        </el-table-column>
        <el-table-column min-width="140" label="创建时间" prop="ctime"></el-table-column>
        <el-table-column min-width="120" label="订单状态" prop="orderStatus">
          <template v-slot="{ row }">
            <template v-if="row.resState !== '1'">
              <el-tag type="warning">货转中</el-tag>
            </template>
            <template v-else-if="['2', '3'].includes(row.hgState)">
              <el-tag type="warning">回购中</el-tag>
            </template>
            <template v-else>
              <el-tag type="warning" v-if="row.orderStatus == '1'">待审批</el-tag>
              <el-tag type="primary" v-if="row.orderStatus == '2'">进行中</el-tag>
              <el-tag type="success" v-if="row.orderStatus == '3'">已完成</el-tag>
              <el-tag type="danger" v-if="row.orderStatus == '4'">驳回作废</el-tag>
            </template>
          </template>
        </el-table-column>

        <el-table-column width="270" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text"
                       @click="$router.push('/ycorderManage/detail?orderId=' + row.orderId + '&orderType=' + orderType)">详情</el-button>
            <el-button type="text" v-if="row.orderStatus == 1 && hasApproval" @click="onAppoval(row)">审批</el-button>
            <!-- 暂定价主订单不显示外部编号编辑入口，仅进行中或已完成的子订单可编辑。 -->
            <el-button type="text" v-if="row.parentOrderId && ['2', '3'].includes(row.orderStatus)" @click="onEditPriceOrderNo(row)">外部点价编号</el-button>
            <el-button type="text" v-if="!row.resPrice && row.hgState === '2' && hasApprovalHg2"
                       @click="onAppovalHgJe(row)">填写补贴金额</el-button>
            <el-button type="text" v-if="row.resPrice && row.hgState === '2' && hasApprovalHg2"
                       @click="onAppovalHg(row)">回购审批</el-button>
            <el-button type="text" v-if="row.resPrice && row.hgState === '3' && hasApprovalHg3"
                       @click="onAppovalHg(row)">回购审批</el-button>
            <el-button type="text" v-if="['2', '3'].includes(row.hgState) && row.resPrice"
                       @click="onDownExcel2(row.orderId)">导出回购单</el-button>
            <!-- <el-button type="text"
              v-if="row.orderStatus == 2 && hasTransfer && row.resState === '1' && !row.parentOrderId"
              @click="onTransfer(row)">货权转让</el-button> -->
            <el-button type="text"
                       v-if="row.orderStatus == 2 && hasEditNum && row.resState === '1' && !row.parentOrderId"
                       @click="onEditNumr(row)">提货配置</el-button>
            <el-button type="text" v-if="row.orderStatus == 2 && hasComplete && row.resState === '1'"
                       @click="onComplete(row)">完成</el-button>
            <el-button type="text" v-if="row.parentOrderId && row.orderStatus === '2' && hasReturn"
                       @click="onReturn(row)">退回</el-button>
            <el-button v-if="hasDel && row.resState === '1'" type="text" @click="deleteRow(row.orderId)"
                       class="del-btn">删除</el-button>
            <el-button v-if="row.orderStatus == 2 && hasRelation" type="text" @click="$router.push('/ycorderManage/relation?orderId=' + row.orderId + '&orderType=' + orderType)">关联</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
                     @current-change="loadData">
      </el-pagination>
    </el-card>

    <el-dialog title="点击时间设置" class="global-dialog" :visible.sync="settingVisible" width="520px">
      <div class="setting-content">
        <el-form :model="settingForm" :rules="settingRules" ref="settingForm">
          <el-form-item label="点价状态" prop="yxStatus">
            <el-radio-group v-model="settingForm.yxStatus">
              <el-radio label="1">正常</el-radio>
              <el-radio label="2">禁止下单</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="settingForm.yxStatus !== '2'" label="点价时间" prop="yxTime">
            <el-time-picker :picker-options="{ format: 'HH:mm' }" @change="timeChange" value-format="HH:mm" is-range
                            v-model="timeArr" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间"
                            placeholder="选择时间范围">
            </el-time-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="settingVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveSetting">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="点击数量设置" class="global-dialog" :visible.sync="settingVisible2" width="520px">
      <div class="setting-content">
        <el-form :model="settingForm2" label-width="120px" :rules="settingRules2" ref="settingForm2">
          <el-form-item label="类型" prop="numId">
            <el-radio-group v-model="settingForm2.numId" @change="loadSetting2">
              <el-radio label="0">成品油</el-radio>
              <el-radio label="1">散油</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="最小数量" prop="orderMinNum">
            <el-input v-model="settingForm2.orderMinNum" placeholder="请输入最小数量"></el-input>
          </el-form-item>
          <el-form-item label="最大数量" prop="orderMaxNum">
            <el-input v-model="settingForm2.orderMaxNum" placeholder="请输入最大数量"></el-input>
          </el-form-item>
          <el-form-item label="单日最大提货量" prop="pickupMaxNum">
            <el-input v-model="settingForm2.pickupMaxNum" placeholder="请输入最大提货量"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="settingVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="saveSetting2">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提货数量设置" class="global-dialog" :visible.sync="editNumVisible" width="520px">
      <div class="setting-content">
        <el-form :model="editNumForm" label-width="120px" :rules="editNumRules" ref="editNumForm">
          <el-form-item label="单日最大提货量" prop="maxNum">
            <el-input v-model="editNumForm.maxNum" placeholder="请输入最大提货量"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editNumVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveEditNum">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="退回" class="global-dialog" :visible.sync="returnVisible" width="520px">
      <div class="setting-content">
        <el-form :model="returnForm" label-width="120px" :rules="returnRules" ref="returnForm">
          <el-form-item label="退回数量" prop="orderQuantity">
            <el-input v-model="returnForm.orderQuantity" placeholder="请输入退回数量"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="returnCancel">取 消</el-button>
        <el-button type="primary" @click="returnConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="释放订单" class="global-dialog" :visible.sync="editStatusVisible" width="520px">
      <div class="setting-content">
        <el-form :model="editStatusForm" :rules="editStatusRules" ref="editStatusForm">
          <el-form-item label="释放类型" prop="orderStatus">
            <el-radio-group v-model="editStatusForm.orderStatus">
              <el-radio label="1">释放至货款</el-radio>
              <el-radio label="2">释放至保证金</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editStatusVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveEditStatus">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="转移订单" class="global-dialog" :visible.sync="transferVisible" width="520px">
      <div class="setting-content">
        <el-form :model="transferForm" label-width="80px" :rules="transferRules" ref="transferForm">
          <el-form-item label="接收用户" prop="userName">
            <!-- <el-select :filterable="true" v-model="transferForm.userName" placeholder="请输入接收用户">
              <el-option v-for="item in userList" :key="item.userId" :label="item.userName"
                :value="item.userId"></el-option>
            </el-select> -->
            <el-input v-model="transferForm.userName" placeholder="请输入接收用户"></el-input>
          </el-form-item>
          <el-form-item prop="resPrice" label="接收单价">
            <el-input v-model="transferForm.resPrice" placeholder="请输入接收单价"></el-input>
          </el-form-item>
          <el-form-item prop="fileList" label="附件">
            <file-upload v-model="transferForm.fileList"></file-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="transferVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveTransfer">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 审批 -->
    <ApprovalDialog urlType="2" :relatedId="rowId" v-if='showDlg' @closeDlg="showDlg = false" @successSave="loadData"
                    :showDlg="showDlg"></ApprovalDialog>

    <!-- 回购审批 -->
    <ApprovalDialog urlType="8" :relatedId="rowId" v-if='showDlg2' @closeDlg="showDlg2 = false" @successSave="loadData"
                    :showDlg="showDlg2"></ApprovalDialog>

    <!-- 回购审批 -->
    <ApprovalDialog urlType="9" :relatedId="rowId" v-if='showDlg3' @closeDlg="showDlg3 = false" @successSave="loadData"
                    :showDlg="showDlg3"></ApprovalDialog>

    <!-- 回购审批 -->
    <ApprovalDialog urlType="10" :relatedId="rowId" v-if='showDlg4' @closeDlg="showDlg4 = false" @successSave="loadData"
                    :showDlg="showDlg4"></ApprovalDialog>

    <!-- 提货日期修改 -->
    <EditDateDlg v-if="showDateDlg" :pickupDate="pickupDate" @successSave="loadData" :orderId="rowId"
                 :showDlg.sync="showDateDlg"></EditDateDlg>
    <el-dialog title="填写外部点价编号" :visible.sync="priceOrderNoVisible" width="480px">
      <el-input v-model="priceOrderNoForm.priceOrderNo" maxlength="100" placeholder="请输入审批后的外部点价编号"></el-input>
      <span slot="footer">
        <el-button @click="priceOrderNoVisible = false">取消</el-button>
        <el-button type="primary" @click="savePriceOrderNo">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import ApprovalDialog from '@/views/zhyc/bondRecord/ApprovalDialog'
import BigNumber from 'bignumber.js'
import EditDateDlg from './EditDateDlg.vue'
import { validNumber3 } from '@/utils/validator'
import { orderDepositType } from '@/utils/dict'
import { mapToObjectArray, copyText } from '@/utils/utils'
import { exportFiles } from '@/utils/globalMethods'

export default {
  name: 'orderManage',
  mixins: [keepAlive],
  components: { ApprovalDialog, EditDateDlg },
  data() {
    return {
      settingVisible: false,
      settingVisible2: false,
      returnVisible: false,
      orderDepositTypeMap: orderDepositType,
      orderDepositTypeList: mapToObjectArray(orderDepositType),
      timeArr: ['', ''],
      settingForm: {
        yxStatus: '',
        yxTime: ''
      },
      returnForm: {
        orderId: '',
        orderQuantity: ''
      },
      settingRules: {
        yxStatus: [{ required: true, message: '请选择点价状态' }],
        yxTime: [{ required: true, message: '请选择点价时间断' }]
      },
      returnRules: {
        orderQuantity: [
          { required: true, message: '请输入退回数量' },
          { pattern: validNumber3, message: '退回数量保留三位小数' }
        ]
      },
      settingForm2: {
        numId: '', // id
        orderMinNum: '', // 最小数量
        orderMaxNum: '', // 最大数量
        pickupMaxNum: '', // 最大提货量
        isBulkOil: '' // 粮油规格
      },
      settingRules2: {
        numId: [{ required: true, message: '请选择类型' }],
        orderMinNum: [{ required: true, message: '请输入最小数量' }],
        orderMaxNum: [{ required: true, message: '请输入最大数量' }],
        pickupMaxNum: [{ required: true, message: '请输入最大提货量' }]
      },
      tableData: [],
      // 1待审核，2进行中，3已结束 4驳回作废
      orderStatusList: [
        {
          label: '待审批',
          value: '1'
        },
        {
          label: '进行中',
          value: '2'
        },
        {
          label: '已完成',
          value: '3'
        },
        {
          label: '驳回作废',
          value: '4'
        }
      ],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        userId: '',
        contractNo: '',
        userName: '',
        orderStatus: '',
        orderNumber: '',
        priceOrderNo: '',
        orderDepositType: '',
        specName: ''
      },
      editStatusVisible: false,
      editStatusForm: {
        orderId: '',
        orderStatus: ''
      },
      editStatusRules: {
        orderStatus: [{ required: true, message: '请选择释放类型' }]
      },
      dateArr: [],
      userList: [],
      showDlg: false,
      showDlg2: false,
      showDlg3: false,
      showDlg4: false,
      rowId: '',
      showDateDlg: false,
      pickupDate: '',
      priceOrderNoVisible: false,
      priceOrderNoForm: { orderId: '', priceOrderNo: '' },
      transferVisible: false,
      transferForm: {
        orderId: '',
        userName: '',
        resPrice: '',
        fileList: []
      },
      transferRules: {
        userName: [{ required: true, message: '请输入接收用户' }],
        resPrice: [
          { required: true, message: '请输入接收单价' },
          { pattern: validNumber3, message: '接收单价保留三位小数' }
        ]
      },
      editNumVisible: false,
      editNumForm: {
        maxNum: ''
      },
      editNumRules: {
        maxNum: [
          { required: true, message: '请输入最大提货量' },
          { pattern: validNumber3, message: '最大提货量保留三位小数' }
        ]
      }
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasApproval() {
      return this.buttonList.includes('approval')
    },
    hasApprovalHg2() {
      return this.buttonList.includes('approvalHg2')
    },
    hasApprovalHg3() {
      return this.buttonList.includes('approvalHg3')
    },
    hasComplete() {
      return this.buttonList.includes('complete')
    },
    hasReturn() {
      return this.buttonList.includes('return')
    },
    hasTransfer() {
      return this.buttonList.includes('transfer')
    },
    hasSetting() {
      return this.buttonList.includes('setting')
    },
    hasSetting2() {
      return this.buttonList.includes('setting2')
    },
    hasExport() {
      return this.buttonList.includes('export')
    },
    hasEditDate() {
      return this.buttonList.includes('editDate')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasRelation() {
      return this.buttonList.includes('relation')
    },
    hasEditNum() {
      return this.buttonList.includes('editNum')
    },
    orderType() {
      console.log(' this.$route.query.orderType : ', this.$route.query.orderType)
      return this.$route.query.orderType || '1'
    }
  },
  created() {
    this.loadUserList()
    this.loadData()
    console.log('this.buttonList', this.buttonList)
  },
  watch: {
    orderType(newV, oldV) {
      if (newV !== oldV) {
        this.onReset()
        this.onSearch()
      }
    }
  },
  methods: {
    downloadPurchaseReport(type) {
      const api = type === 'basis' ? this.$apis.yxcOrderManage.downloadBasisContractReport : this.$apis.yxcOrderManage.downloadBulkPurchaseExecutionReport
      const name = type === 'basis' ? '基差合同点价情况表.pdf' : '散油采购合同执行表.pdf'
      const params = this.dateArr && this.dateArr.length ? { startDate: this.dateArr[0], endDate: this.dateArr[1] } : {}
      // 两类采购报表统一由公共工具使用 POST 发送 JSON 日期条件，并按 Blob 下载 PDF。
      exportFiles(api, params, name)
    },
    onEditPriceOrderNo(row) {
      this.priceOrderNoForm = { orderId: row.orderId, priceOrderNo: row.priceOrderNo || '' }
      this.priceOrderNoVisible = true
    },
    savePriceOrderNo() {
      if (!this.priceOrderNoForm.priceOrderNo) return this.$message.warning('请输入外部点价编号')
      this.$axios.post(this.$apis.yxcOrderManage.updateYxcPriceOrderNo, this.priceOrderNoForm).then(() => {
        this.priceOrderNoVisible = false
        this.loadData()
      })
    },
    async handleCopyOrderNo(text) {
      const success = await copyText(text)
      if (success) {
        this.$message.success('复制成功')
      } else {
        this.$message.error('复制失败，请手动复制')
      }
    },
    onTransfer(row) {
      this.transferForm.orderId = row.orderId
      this.transferVisible = true
      this.$nextTick(() => {
        this.$refs.transferForm.resetFields()
      })
    },
    onEditNumr(row) {
      this.editNumVisible = true
      this.$nextTick(() => {
        this.$refs.editNumForm.resetFields()
        this.editNumForm.orderId = row.orderId
        this.editNumForm.maxNum = row.maxNum
      })
    },
    saveEditNum() {
      this.$refs.editNumForm.validate().then(() => {
        this.$axios.post(this.$apis.yxcOrderManage.updateYxcPriceOrderNum, this.editNumForm).then(res => {
          this.editNumVisible = false
          this.loadData()
        })
      })
    },
    saveTransfer() {
      this.$refs.transferForm.validate(valid => {
        if (valid) {
          this.$axios.post(this.$apis.yxcOrderManage.insertYxcPriceOrderRes, this.transferForm).then(res => {
            this.transferVisible = false
            this.loadData()
          })
        }
      })
    },
    onComplete(row) {
      this.editStatusForm.orderId = row.orderId
      this.saveEditStatus()
      // this.editStatusVisible = true
      // this.$nextTick(() => {
      //   this.$refs.editStatusForm.resetFields()
      // })
    },
    onReturn(row) {
      if (this.orderType === '1') {
        this.returnForm.orderId = row.orderId
        this.returnVisible = true
      } else if (this.orderType === '2') {
        this.$confirm('确认退回该订单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post(this.$apis.yxcOrderManage.backYxcPriceOrder, {
            orderId: row.orderId
          }).then(res => {
            // this.$message.success('退回成功')
            this.loadData()
          })
        })
      }
    },
    returnConfirm() {
      this.$refs.returnForm.validate(valid => {
        if (valid) {
          this.$axios.post(this.$apis.yxcOrderManage.backYxcPriceOrder, this.returnForm).then(res => {
            this.returnVisible = false
            this.loadData()
          })
        }
      })
    },
    returnCancel() {
      this.returnVisible = false
      this.$refs.returnForm.resetFields()
    },
    saveEditStatus() {
      this.$confirm('确认完成该订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.yxcOrderManage.endYxcPriceOrderDate, this.editStatusForm).then(res => {
          this.editStatusVisible = false
          this.loadData()
        })
      })
      // this.$refs.editStatusForm.validate(valid => {
      //   if (valid) {
      //   }
      // })
    },
    deleteRow(orderId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.yxcOrderManage.deleteYxcPriceOrder, {
          orderId
        }).then(() => {
          this.loadData()
        })
      })
    },

    onEditDate(row) {
      this.pickupDate = row.pickupDate || ''
      this.rowId = row.orderId
      this.showDateDlg = true
    },
    onSetting() {
      this.settingVisible = true
      this.loadSetting()
    },
    onSetting2() {
      this.settingVisible2 = true
      this.loadSetting2(0)
    },
    timeChange(data) {
      if (data && data.length > 0) {
        this.settingForm.yxTime = data[0] + '-' + data[1]
      } else {
        this.settingForm.yxTime = ''
      }
    },
    loadSetting() {
      this.$axios.get(this.$apis.orderManage.selectYxStatus).then(res => {
        if (res.yxTime) {
          this.timeArr = res.yxTime.split('-')
        }
        this.settingForm = res
      })
    },
    loadSetting2(isBulkOil) {
      this.$axios.get(this.$apis.yxcOrderManage.selectYxcPriceNumByNumId, {
        numId: isBulkOil
      }).then(res => {
        this.settingForm2 = res || { numId: '0', orderMinNum: '1', orderMaxNum: '50000', pickupMaxNum: '1700', isBulkOil: '0' }
      })
    },
    saveSetting() {
      this.$refs.settingForm.validate(valid => {
        if (valid) {
          this.$axios.post(this.$apis.orderManage.updateYxStatus, this.settingForm).then(res => {
            this.settingVisible = false
          })
        }
      })
    },
    saveSetting2() {
      this.$refs.settingForm2.validate(valid => {
        if (valid) {
          this.$axios.post(this.$apis.yxcOrderManage.updateYxcPriceNum, this.settingForm2).then(res => {
            this.settingVisible2 = false
          })
        }
      })
    },
    onDownExcel() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      let startDate = null
      let endDate = null
      if (this.dateArr && this.dateArr.length > 0) {
        startDate = this.dateArr[0]
        endDate = this.dateArr[1]
      }
      this.$axios.post(this.$apis.yxcOrderManage.exportYxcPriceOrder, {
        ...this.searchForm,
        startDate,
        endDate
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const disposition = res.headers['content-disposition']
          const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
          this.downloadFile(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    onDownExcel2(orderId) {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.$axios.post(this.$apis.yxcOrderManage.txYxcHgPdf, {
        orderId
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const contentDisposition = res.headers['content-disposition']

          let fileName = '回购单.pdf'

          if (contentDisposition) {
            // 匹配 filename="xxx.pdf"
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = fileNameMatch[1] // 拿到 ZJ202603291451445378.pdf
            }
          }
          // const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
          console.log('fileName', fileName)
          this.downloadFile2(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    downloadFile2(data, fileName) {
      const blob = new Blob([data], { type: 'application/pdf' })
      const downloadElement = document.createElement('a')
      // 创建下载的链接
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      // 下载后文件名
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      // 释放掉blob对象
      window.URL.revokeObjectURL(href)
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const downloadElement = document.createElement('a')
      // 创建下载的链接
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      // 下载后文件名
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      // 释放掉blob对象
      window.URL.revokeObjectURL(href)
    },
    onAppoval(row) {
      this.rowId = row.orderId
      this.showDlg = true
    },
    onAppovalHg(row) {
      this.rowId = row.orderId
      if (row.hgState === '2') {
        this.showDlg2 = true
      } else {
        this.showDlg3 = true
      }
    },
    onAppovalHgJe(row) {
      this.rowId = row.orderId
      this.showDlg4 = true
    },
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, { userType: '3' }).then(res => {
        this.userList = res.list || []
      })
    },
    loadData() {
      const params = {
        page: this.page,
        ...this.searchForm,
        orderType: this.orderType
      }
      console.log('params', params)
      if (this.dateArr && this.dateArr.length > 0) {
        params.startDate = this.dateArr[0]
        params.endDate = this.dateArr[1]
      } else {
        params.startDate = undefined
        params.endDate = undefined
      }
      this.$axios.get(this.$apis.yxcOrderManage.selectYxcPriceOrderByPage, params).then(res => {
        res.list.forEach(item => {
          const orderQuantity = new BigNumber(item.orderQuantity || 0)
          const usedQuantity = new BigNumber(item.usedQuantity || 0)
          // 扣除已提货和提货进行中的数量，超量提货时直接展示负数余量。
          const num = orderQuantity.minus(usedQuantity).minus(item.usedAddQuantity || 0)
          item.kyQuantity = Number(num.toFixed(3))
        })
        this.tableData = res.list
        this.total = res.total
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.dateArr = []
      this.$refs.formData.resetFields()
      this.onSearch()
    }
  }
}
</script>

<style scoped lang="scss">
.setting-content {
  padding: 20px;
}
</style>
